export const VALIDATE_MPIN = "VALIDATE/mpin";
